export function BannerPaleGreen400({
  width = 1080,
  height = 210,
}: {
  width?: string | number;
  height?: string | number;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 1080 210"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_779_8894)">
        <rect width="1080" height="210" fill="#759993" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M850.226 219.124L924.357 176.325C935.003 170.178 938.452 156.337 932.342 145.755L920.306 124.907C918.131 121.148 912.974 120.944 910.529 124.632C907.6 129.064 903.572 133.204 899.804 135.379C891.572 140.132 880.763 137.263 876.033 129.07C871.302 120.877 874.223 110.082 882.455 105.329C886.236 103.146 891.822 101.736 897.124 101.414C901.543 101.14 903.596 96.7702 901.772 92.8058L889.698 71.8938C883.623 61.3714 870.168 57.7661 859.646 63.8412L838.529 76.0329C834.748 78.2158 830.176 75.8384 829.92 71.4314C829.619 66.1428 828.229 60.5762 826.056 56.813C821.327 48.6222 810.523 45.7528 802.291 50.5001C794.064 55.255 791.147 66.0468 795.876 74.2376C798.049 78.0007 802.174 81.9882 806.604 84.8926C810.293 87.3178 810.065 92.4666 806.284 94.6496L785.168 106.841C774.645 112.916 771.04 126.371 777.115 136.894L789.189 157.806C791.71 161.368 796.522 161.774 798.968 158.085C801.897 153.653 805.911 149.521 809.693 147.338C817.925 142.585 828.734 145.454 833.464 153.647C838.195 161.84 835.274 172.636 827.042 177.388C823.275 179.564 817.675 180.982 812.373 181.303C807.957 181.577 805.556 186.142 807.72 189.903L819.759 210.755C825.868 221.337 839.58 225.271 850.226 219.124Z"
          fill="#96BCB6"
        />
        <path
          d="M960.434 86.361C962.379 86.9884 964.464 85.9208 965.091 83.9764L965.246 83.4962C967.043 77.9281 963.986 71.9577 958.417 70.1609C952.849 68.3641 946.879 71.4214 945.082 76.9895L944.927 77.4696C944.3 79.414 945.367 81.499 947.312 82.1264L960.434 86.361Z"
          fill="#4F6C67"
        />
        <path
          d="M918.749 15.3818C920.713 11.9807 919.548 7.63182 916.147 5.66823L915.307 5.18338C905.567 -0.439633 893.114 2.89731 887.491 12.6367C881.868 22.376 885.205 34.8296 894.944 40.4527L895.784 40.9375C899.185 42.9011 903.534 41.7358 905.497 38.3348L918.749 15.3818Z"
          fill="#4F6C67"
        />
      </g>
      <defs>
        <clipPath id="clip0_779_8894">
          <rect width="1080" height="210" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
